<template>
  <div>
    <v-card
      flat
    >
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">List of Customers</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-row>
        <v-col
          md="12"
          cols="12"
        ></v-col>
        <v-col
          md="6"
          cols="12"
        >
          <span class="headline font-weight-light"
                v-if="collectors_data.length>0">
                                                Print
                                                <v-icon
                                                  class="mr-2"
                                                  color="warning"
                                                  @click="print_data()"
                                                >
                                                {{ icons.mdiPrinter }}
                                                </v-icon>
                                            </span>
        </v-col>
      </v-row>
      <v-data-table dense
                    :headers="headers"
                    :items="collectors_data"
      >
        <template v-slot:item="{ item }">
          <tr
            @click="activerow(item)"
            :class="{'info black--text': item.id===selectedDepositId}"
          >
            <td>{{ item.date_registered }}</td>
            <td>
              {{ item.company_name }}
            </td>
            <td>
              {{ item.address }}
            </td>
            <td>
              {{ item.type_of_business }}
            </td>
            <td>
              {{ item.contact_no }}
            </td>
            <td>
              <div v-if="item.is_active===0">
                <v-chip small color="error" dark>Deactivated</v-chip>
              </div>
              <div v-else>
                <v-chip small color="success" dark>Active</v-chip>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <snack-bar-dialog
      :snackbar_flag="this.snackbar"
      :color="this.snackbar_color"
      :snackbar_text="this.snackbar_text"
    />
  </div>
</template>

<script>
import {mdiPrinter, mdiDelete, mdiEyeOutline, mdiToggleSwitch} from '@mdi/js'
import {mapGetters, mapActions} from "vuex";
import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'
import moment from 'moment'

export default {
  components: {
    snackBarDialog,
  },
  mounted() {
    this.list_of_customers({
      month_of: 'All',
    })
      .then(response => {
        this.selectedDepositId = -1
        this.collectors_data = response.data
        this.collectors_remittances_data = []
      })
      .catch(error => {
        console.log(error)
      })
  },
  setup() {
    return {
      icons: {
        mdiPrinter,
        mdiDelete,
        mdiEyeOutline,
        mdiToggleSwitch,
      },
    }
  },
  data() {
    return {
      headers: [
        {text: 'DATE', value: 'date_registered', sortable: false},
        {text: 'NAME', value: 'company_name', sortable: false},
        {text: 'ADRESS', value: 'address', sortable: false},
        {text: 'TYPE', value: 'type_of_business', sortable: false},
        {text: 'CONTACT #', value: 'contact_no', sortable: false},
        {text: 'STATUS', value: 'contact_no', sortable: false},
      ],

      data: [],
      bank_depositories: [],
      collectors_data: [],
      collectors_remittances_data: [],

      month_of_items: [],
      month_of: '',
      type_of_payment: '',
      type_of_order: '',
      selectedDepositId: -1,
    }
  },
  computed: {
    ...mapGetters('authentication', ['position', 'company_name', 'branch_id', 'branch_contact_no', 'branch_address', 'branch', 'branch_id_selected']),
    ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text', 'company_logo']),
  },
  methods: {
    ...mapActions('system_data', ['change_snackbar']),
    ...mapActions('customer', ['list_of_customers']),
    date_format(value) {
      return moment(value)
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    activerow(value) {
      this.data = value
      this.bank_depositories = value.bank_depositories
      this.selectedDepositId = value.id;
      this.collectors_remittances_data = value.liquidations
    },
    get_amount_of_purchase_order(value) {
      var amm = 0
      value.forEach(function (item) {
        amm += parseFloat(item.total)
      })
      return amm;
    },
    print_data() {
      var imgData = this.company_logo
      var payments_array = []

      payments_array.push(
        [
          {text: 'DATE', alignment: 'center', style: 'label'},
          {text: 'NAME', alignment: 'center', style: 'label'},
          {text: 'ADDRESS', alignment: 'center', style: 'label'},
          {text: 'TYPE', alignment: 'center', style: 'label'},
          {text: 'CONTACT #', alignment: 'center', style: 'label'},
          {text: 'STATUS', alignment: 'center', style: 'label'},
        ]
      )
      if (this.collectors_data.length > 0) {
        var total_amount = 0
        this.collectors_data.forEach(function (item, index) {
          payments_array.push(
            [
              {text: item.date_registered, alignment: 'center'},
              {text: item.company_name, alignment: 'center'},
              {text: item.address, alignment: 'center'},
              {text: item.type_of_business, alignment: 'center'},
              {text: item.contact_no, alignment: 'center'},
              {
                text: (item.is_active === 0 ? 'DEACTIVATED' : 'ACTIVE'),
                alignment: 'center'
              },
            ]
          )
        })
      } else {
        payments_array.push(
          [
            '----',
            '----',
            '----',
            '----',
            '----',
            '----',
            '----',
          ]
        )
      }
      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      var docDefinition = {
        pageSize: {
          width: 612,
          height: 936,
        },
        pageOrientation: 'PORTRAIT',
        content: [
          {
            columns: [
              {image: imgData, width: 54, height: 54, style: 'logo'},
              {
                stack: [
                  this.company_name,
                  {text: this.branch_address, style: 'subheader'},
                  {
                    text: '* CONTACT NO.: ' + this.branch_contact_no,
                    style: 'subheader'
                  },
                ],
                style: 'header'
              },
            ]
          },
          {text: 'LIST OF CUSTOMERS', style: 'title'},
          '================================================================================',
          {text: 'Printed as of: ' + moment().format('MMMM D, YYYY'), style: 'printed_label'},
          {text: 'Branch: ' + this.branch_selected, style: 'main_info'},
          ' ',
          {
            style: 'tableExample',
            color: '#444',
            table: {
              widths: [50, 150, 150, 50, 50, 50,],
              body: payments_array,
            },
            layout: {
              fillColor: function (rowIndex) {
                return (rowIndex === 0) ? '#CCCCCC' : null;
              },
            },
          },
          {
            stack: [
              {
                columns: [
                  {text: 'Prepared By: ', style: 'aa_top_margin'},
                  {text: 'Received By:', style: 'cashier_top_margin'},
                  {text: ''},
                ]
              },
              {
                columns: [
                  {text: '', style: 'aa_for'},
                  {text: '', style: 'cashier_for'},
                  {text: ''},
                ]
              },
              {
                columns: [
                  {text: '_________________________________', style: 'aa_line'},
                  {text: '_________________________________', style: 'cashier_line'},
                  {text: ''},
                ]
              },
              {
                columns: [
                  {text: 'Teller', style: 'aa_placeholder'},
                  {text: 'Head Office', style: 'cashier_placeholder'},
                  {text: ''},
                ]
              },
            ]
          },

        ],
        footer: {
          columns: [
            {
              text: 'Generated with GL-Express System',
              alignment: 'center',
              style: 'tableExample'
            }
          ]
        },
        styles: {
          header: {
            fontSize: 21,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 20]//[left, top, right, bottom]
          },
          subheader: {
            fontSize: 12
          },
          title: {
            fontSize: 15,
            alignment: 'center',
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0]//[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 9,
            margin: [0, 4, 0, 0]//[left, top, right, bottom]
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
          },
          sub_info: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
          },
          tableExample: {
            fontSize: 9,
          },

          aa_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          bm_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          cs_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          aa_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          aa_placeholder: {
            margin: [15, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          aa_for: {
            margin: [0, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_for: {
            margin: [2, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_for: {
            margin: [3, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_for: {
            margin: [3, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_placeholder: {
            margin: [26, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_placeholder: {
            margin: [2, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_placeholder: {
            margin: [5, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          au_placeholder: {
            margin: [2, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_for: {
            margin: [2, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
        },
      }
      pdfMake.createPdf(docDefinition).open();
    },
  }
}
</script>
